import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import PageHeader from '../../components/PageHeader';
import { Search, Filter, ArrowUpDown, Eye, Check, X, FileText, Sparkles, AlertTriangle, ThumbsUp, MoreHorizontal } from 'lucide-react';
// Mock data
const mockProofs = [{
  id: 1,
  user: {
    name: 'Marco Rossi',
    email: 'marco.rossi@email.it',
    city: 'Milano',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  action: 'Riciclo Plastica',
  date: '15/05/2025',
  attachments: 2,
  status: 'In revisione',
  context: 'Challenge: Zero Waste Week'
}, {
  id: 2,
  user: {
    name: 'Giulia Bianchi',
    email: 'giulia.bianchi@email.it',
    city: 'Roma',
    avatar: 'https://i.pravatar.cc/150?img=2'
  },
  action: 'Mobilità Sostenibile',
  date: '14/05/2025',
  attachments: 1,
  status: 'Approvata',
  context: 'Challenge: Bike to Work'
}, {
  id: 3,
  user: {
    name: 'Luca Verdi',
    email: 'luca.verdi@email.it',
    city: 'Torino',
    avatar: 'https://i.pravatar.cc/150?img=3'
  },
  action: 'Spesa Sfusa',
  date: '14/05/2025',
  attachments: 3,
  status: 'Inviata',
  context: 'Challenge: Plastic Free'
}];
const mockFeed = [{
  id: 1,
  user: 'Elena Neri',
  action: 'Ho piantato un albero!',
  image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=500&auto=format&fit=crop&q=60',
  likes: 24,
  status: 'Approvata'
}, {
  id: 2,
  user: 'Paolo Gialli',
  action: 'Pulizia spiaggia',
  image: 'https://images.unsplash.com/photo-1618477461853-5f8dd68aa1fd?w=500&auto=format&fit=crop&q=60',
  likes: 15,
  status: 'In revisione'
}];
const mockReports = [{
  id: 1,
  proofId: 101,
  reason: 'Contenuto ingannevole',
  date: '15/05/2025',
  status: 'Nuova',
  preview: 'Foto non originale presa da internet'
}, {
  id: 2,
  proofId: 102,
  reason: 'Spam',
  date: '14/05/2025',
  status: 'Risolta',
  preview: 'Link pubblicitario nei commenti'
}];
const LMSModeration = () => {
  const [activeTab, setActiveTab] = useState('coda');
  const [selectedProof, setSelectedProof] = useState<any>(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Approvata':
        return 'bg-green-100 text-green-800';
      case 'In revisione':
        return 'bg-yellow-100 text-yellow-800';
      case 'Non valida':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const handleApprove = () => {
    // Simulate approval
    alert('Prova approvata con successo!');
    setSelectedProof(null);
  };
  const handleReject = () => {
    // Simulate rejection
    if (!rejectReason) return;
    alert(`Prova respinta. Motivo: ${rejectReason}`);
    setShowRejectModal(false);
    setSelectedProof(null);
    setRejectReason('');
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2657">
      <div className="w-20 flex-shrink-0" data-id="element-2658">
        <Sidebar data-id="element-2659" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2660">
        <Topbar data-id="element-2661" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2662">
          <PageHeader title="Moderazione" subtitle="Gestisci prove, feed e segnalazioni" data-id="element-2663" />

          {/* Tabs */}
          <div className="border-b border-gray-200 mb-6" data-id="element-2664">
            <nav className="-mb-px flex space-x-8" data-id="element-2665">
              {['Coda prove', 'Feed prove condivise', 'Segnalazioni'].map(tab => {
              const tabKey = tab === 'Coda prove' ? 'coda' : tab === 'Feed prove condivise' ? 'feed' : 'segnalazioni';
              return <button key={tab} onClick={() => setActiveTab(tabKey)} className={`
                      whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                      ${activeTab === tabKey ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                    `} data-id="element-2666">
                      {tab}
                    </button>;
            })}
            </nav>
          </div>

          {/* Tab Content */}
          {activeTab === 'coda' && <div className="space-y-4" data-id="element-2667">
              {/* Filters */}
              <div className="flex gap-4 mb-4" data-id="element-2668">
                <div className="relative flex-1 max-w-md" data-id="element-2669">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-2670" />
                  <input type="text" placeholder="Cerca per nome o email..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2671" />
                </div>
                <select className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2672">
                  <option value="" data-id="element-2673">Tutti gli stati</option>
                  <option value="Inviata" data-id="element-2674">Inviata</option>
                  <option value="In revisione" data-id="element-2675">In revisione</option>
                  <option value="Approvata" data-id="element-2676">Approvata</option>
                </select>
                <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-2677">
                  <ArrowUpDown className="h-4 w-4" data-id="element-2678" />
                  Data
                </button>
              </div>

              {/* Table */}
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2679">
                <table className="w-full" data-id="element-2680">
                  <thead className="bg-gray-50" data-id="element-2681">
                    <tr data-id="element-2682">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2683">
                        Utente
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2684">
                        Azione
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2685">
                        Data invio
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2686">
                        Allegati
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2687">
                        Stato
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2688">
                        Azioni
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-2689">
                    {mockProofs.map(proof => <tr key={proof.id} className="hover:bg-gray-50" data-id="element-2690">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2691">
                          <div className="flex items-center" data-id="element-2692">
                            <img src={proof.user.avatar} alt="" className="h-8 w-8 rounded-full mr-3" data-id="element-2693" />
                            <div className="text-sm font-medium text-gray-900" data-id="element-2694">
                              {proof.user.name}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-2695">
                          {proof.action}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2696">
                          {proof.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2697">
                          {proof.attachments} file
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2698">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadge(proof.status)}`} data-id="element-2699">
                            {proof.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2700">
                          <button onClick={() => setSelectedProof(proof)} className="text-green-600 hover:text-green-700" data-id="element-2701">
                            Dettagli
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}

          {activeTab === 'feed' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2702">
              {mockFeed.map(item => <div key={item.id} className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2703">
                  <div className="h-48 overflow-hidden" data-id="element-2704">
                    <img src={item.image} alt={item.action} className="w-full h-full object-cover" data-id="element-2705" />
                  </div>
                  <div className="p-4" data-id="element-2706">
                    <div className="flex justify-between items-start mb-2" data-id="element-2707">
                      <div data-id="element-2708">
                        <h3 className="font-medium text-gray-900" data-id="element-2709">
                          {item.user}
                        </h3>
                        <p className="text-sm text-gray-500" data-id="element-2710">{item.action}</p>
                      </div>
                      <span className={`px-2 py-1 text-xs rounded-full ${getStatusBadge(item.status)}`} data-id="element-2711">
                        {item.status}
                      </span>
                    </div>
                    <div className="flex items-center justify-between mt-4" data-id="element-2712">
                      <div className="flex items-center text-gray-500 text-sm" data-id="element-2713">
                        <ThumbsUp className="h-4 w-4 mr-1" data-id="element-2714" />
                        {item.likes}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>}

          {activeTab === 'segnalazioni' && <div className="space-y-4" data-id="element-2715">
              {mockReports.map(report => <div key={report.id} className="bg-white rounded-lg border border-gray-200 p-4 flex items-center justify-between" data-id="element-2716">
                  <div data-id="element-2717">
                    <div className="flex items-center gap-2 mb-1" data-id="element-2718">
                      <span className="font-medium text-gray-900" data-id="element-2719">
                        {report.reason}
                      </span>
                      <span className={`px-2 py-0.5 text-xs rounded-full ${report.status === 'Nuova' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`} data-id="element-2720">
                        {report.status}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mb-1" data-id="element-2721">
                      {report.preview}
                    </p>
                    <p className="text-xs text-gray-400" data-id="element-2722">{report.date}</p>
                  </div>
                  <div className="flex gap-2" data-id="element-2723">
                    <button className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm hover:bg-gray-50" data-id="element-2724">
                      Apri contenuto
                    </button>
                    <button className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm hover:bg-green-700" data-id="element-2725">
                      Segna come risolta
                    </button>
                  </div>
                </div>)}
            </div>}
        </main>
      </div>

      {/* Proof Detail Drawer */}
      {selectedProof && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setSelectedProof(null)} data-id="element-2726" />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white shadow-2xl z-50 overflow-y-auto" data-id="element-2727">
            <div className="p-6" data-id="element-2728">
              <div className="flex items-center justify-between mb-6" data-id="element-2729">
                <h2 className="text-xl font-bold" data-id="element-2730">Dettaglio Prova</h2>
                <button onClick={() => setSelectedProof(null)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-2731">
                  <X className="h-5 w-5" data-id="element-2732" />
                </button>
              </div>

              {/* User Info */}
              <div className="flex items-center mb-6 p-4 bg-gray-50 rounded-lg" data-id="element-2733">
                <img src={selectedProof.user.avatar} alt="" className="h-12 w-12 rounded-full mr-4" data-id="element-2734" />
                <div data-id="element-2735">
                  <h3 className="font-medium text-gray-900" data-id="element-2736">
                    {selectedProof.user.name}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-2737">
                    {selectedProof.user.email} • {selectedProof.user.city}
                  </p>
                </div>
              </div>

              {/* Context */}
              <div className="mb-6" data-id="element-2738">
                <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2739">
                  Contesto
                </h4>
                <p className="text-sm text-gray-900 bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-2740">
                  {selectedProof.context}
                </p>
              </div>

              {/* Attachments */}
              <div className="mb-6" data-id="element-2741">
                <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2742">
                  Allegati
                </h4>
                <div className="space-y-2" data-id="element-2743">
                  {[1, 2].map(i => <div key={i} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2744">
                      <div className="flex items-center" data-id="element-2745">
                        <FileText className="h-5 w-5 text-gray-400 mr-3" data-id="element-2746" />
                        <div data-id="element-2747">
                          <p className="text-sm font-medium text-gray-900" data-id="element-2748">
                            foto_prova_{i}.jpg
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-2749">JPG • 2.4 MB</p>
                        </div>
                      </div>
                      <div className="flex gap-2" data-id="element-2750">
                        <button className="text-xs text-blue-600 hover:underline" data-id="element-2751">
                          Anteprima
                        </button>
                        <button className="text-xs text-gray-600 hover:underline" data-id="element-2752">
                          Scarica
                        </button>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* AI Support */}
              <div className="mb-8 bg-gradient-to-br from-purple-50 via-blue-50 to-cyan-50 rounded-lg border border-purple-200/50 p-4" data-id="element-2753">
                <div className="flex items-center gap-2 mb-3" data-id="element-2754">
                  <Sparkles className="h-4 w-4 text-purple-600" data-id="element-2755" />
                  <h4 className="text-sm font-semibold text-purple-900" data-id="element-2756">
                    Supporto AI (beta)
                  </h4>
                </div>
                <div className="space-y-2 text-sm" data-id="element-2757">
                  <div className="flex justify-between" data-id="element-2758">
                    <span className="text-gray-600" data-id="element-2759">Coerenza contenuto:</span>
                    <span className="font-medium text-green-600" data-id="element-2760">Alta</span>
                  </div>
                  <div className="flex justify-between" data-id="element-2761">
                    <span className="text-gray-600" data-id="element-2762">Data rilevata:</span>
                    <span className="font-medium text-gray-900" data-id="element-2763">
                      15/01/2025
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-2764">
                    <span className="text-gray-600" data-id="element-2765">Fonte:</span>
                    <span className="font-medium text-gray-900" data-id="element-2766">
                      Foto originale
                    </span>
                  </div>
                  <div className="mt-3 pt-3 border-t border-purple-200/50" data-id="element-2767">
                    <span className="text-gray-600 block mb-1" data-id="element-2768">
                      Suggerimento:
                    </span>
                    <span className="font-medium text-green-700 bg-green-50 px-2 py-1 rounded" data-id="element-2769">
                      Approva
                    </span>
                  </div>
                </div>
              </div>

              {/* Footer Actions */}
              {!showRejectModal ? <div className="flex gap-3" data-id="element-2770">
                  <button onClick={() => setShowRejectModal(true)} className="flex-1 px-4 py-2 border border-red-200 text-red-700 rounded-lg hover:bg-red-50 transition-colors" data-id="element-2771">
                    Non valida
                  </button>
                  <button onClick={handleApprove} className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2" data-id="element-2772">
                    <Check className="h-4 w-4" data-id="element-2773" />
                    Approva
                  </button>
                </div> : <div className="space-y-3" data-id="element-2774">
                  <textarea value={rejectReason} onChange={e => setRejectReason(e.target.value)} placeholder="Messaggio all'utente (obbligatorio)" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none h-24" data-id="element-2775" />
                  <div className="flex gap-3" data-id="element-2776">
                    <button onClick={() => setShowRejectModal(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2777">
                      Annulla
                    </button>
                    <button onClick={handleReject} disabled={!rejectReason} className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2778">
                      Invia esito
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </>}
    </div>;
};
export default LMSModeration;